import React, { Component } from "react";
import { PRODUCT_IMAGE_BASE_URL, CALCULATOR_API } from "../constants";
import IconInfo from "../components/IconInfo";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { addQuoteItem } from "../redux/actions";
import style from "./MdsCalculator.module.css";
import { OnBlurInput } from "../components/OnBlurInput";
import { Button } from "react-bootstrap";

class MdsCalculator extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hasPrintServer: false,
      isMobilePrinterRequired: false,
      isLoading: false,
      isSuccess: false,
      errorMessage: "",
      totalAddedQty: 0,
      numberOfDevice: 0,
      numberOfDeviceToManage: 0,
      numberOfPrintServer: 0,
      numberOfStaff: 0,
      requireDiscoveryAssessmentPerformed: false
    };
  }

  handleInputChange = e => {
    this.setState({
      [e.target.name]: parseInt(e.target.value, 10)
    });
  };

  get isAssessmentMandatory() {
    return (
      this.state.numberOfDeviceToManage >= 21 ||
      this.state.numberOfPrintServer >= 2 ||
      this.state.numberOfStaff >= 500
    );
  }

  handleFormSubmit = async e => {
    e.preventDefault();

    this.setState({
      isLoading: true,
      isSuccess: false,
      errorMessage: "",
      totalAddedQty: 0
    });

    try {
      const searchParams = new URLSearchParams(new FormData(e.target));
      const url = `${CALCULATOR_API}?${searchParams.toString()}`;
      const response = await fetch(url);
      const jsonResponse = await response.json();

      if (jsonResponse.has_error === 1) {
        this.setState({ errorMessage: jsonResponse.message });
        return;
      }

      jsonResponse.items.forEach(product =>
        this.props.addQuoteItem({
          productId: product.id,
          sku: product.sku,
          name: product.name,
          price: product.price,
          image: product.image ? PRODUCT_IMAGE_BASE_URL + product.image : null,
          qty: product.qty,
          type: "simple"
        })
      );

      this.setState({
        isSuccess: true,
        totalAddedQty: jsonResponse.total_qty
      });
    } catch (e) {
      this.setState({ errorMessage: e.message });
    } finally {
      this.setState({ isLoading: false });
    }
  };

  render() {
    return (
      <div className="mdscalculator_container calculator_container">
        <div className="container">
          <h3>
            <span className="add_software_link">MDS Solution</span>
          </h3>
          <hr className="style1" />
          <h5>
            Complete the following questions to configure software solutions to
            add to quote
          </h5>
          <br />

          {this.state.errorMessage && (
            <div className="messages-block">
              <ul class="messages">
                <li class="error-msg">
                  <ul>
                    <li>
                      <span>{this.state.errorMessage}</span>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          )}

          <form
            action="calculator/index/processQuestionnaire"
            id="calculator_questionnaire_form"
            method="post"
            onSubmit={this.handleFormSubmit}
          >
            <table className="table table-borderless">
              <tbody>
                <tr>
                  <td>
                    How many staff does the company have?
                    <div className={style.tooltip}>
                      <IconInfo />
                      <div className={style.tooltipText}>
                        Please enter the total number of users who need to be
                        able to print?
                        <br />
                        <br />
                        Must be no more than 500
                      </div>
                    </div>
                  </td>
                  <td>
                    <OnBlurInput
                      type="number"
                      id="numberOfStaff"
                      name="numberOfStaff"
                      value={this.state.numberOfStaff}
                      onConfirm={this.handleInputChange}
                      placeholder="# of staff"
                      min="1"
                      max="500"
                      required={true}
                    />
                  </td>
                </tr>
                <tr>
                  <td>How long is the contract term?</td>
                  <td>
                    <select id="month" name="month" defaultValue="12">
                      <option value="12">12 months</option>
                      <option value="24">24 months</option>
                      <option value="36">36 months</option>
                      <option value="48">48 months</option>
                      <option value="60">60 months</option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <td>
                    How many devices will be using the software?
                    <div className={style.tooltip}>
                      <IconInfo />
                      <div className={style.tooltipText}>
                        Please enter the total number of imageRUNNER ADVANCE
                        (MEAP Enabled) devices
                        <br />
                        <br />
                        Must be no more than 50
                      </div>
                    </div>
                  </td>
                  <td>
                    <OnBlurInput
                      type="number"
                      id="numberOfDevice"
                      name="numberOfDevice"
                      size="30"
                      min="1"
                      max="50"
                      value={this.state.numberOfDevice}
                      onConfirm={this.handleInputChange}
                      placeholder="# of devices (up to 50)"
                      required={true}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    How many Devices need to be managed?
                    <div className={style.tooltip}>
                      <IconInfo />
                      <div className={style.tooltipText}>
                        Please enter the total number of devices that need to be
                        managed
                        <br />
                        <br />
                        Must be no less than the number of devices
                      </div>
                    </div>
                  </td>
                  <td>
                    <OnBlurInput
                      type="number"
                      id="numberOfDeviceToManage"
                      name="numberOfDeviceToManage"
                      size="30"
                      value={this.state.numberOfDeviceToManage}
                      onConfirm={this.handleInputChange}
                      min={this.state.numberOfDevice}
                      max="50"
                      required={true}
                      placeholder="# of devices to be managed"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    How many Card readers do you require for Secure Print?
                    <div className={style.tooltip}>
                      <IconInfo />
                      <div className={style.tooltipText}>
                        Please enter the total number of card readers required
                        for Secure Print
                        <br />
                        <br />
                        Must be no more than 50
                      </div>
                    </div>
                  </td>
                  <td>
                    <OnBlurInput
                      type="number"
                      id="numberOfCardReader"
                      name="numberOfCardReader"
                      size="30"
                      value=""
                      min="1"
                      max="50"
                      required={true}
                      placeholder="# of card readers"
                    />
                  </td>
                </tr>
                <tr>
                  <td>Does the company have printer server infrastructure?</td>
                  <td>
                    <input
                      id="hasPrintServerYes"
                      name="hasPrintServer"
                      type="radio"
                      value="1"
                      checked={this.state.hasPrintServer}
                      onChange={() => this.setState({ hasPrintServer: true })}
                    />
                    <label htmlFor="hasPrintServerYes">Yes</label>
                    &nbsp;&nbsp;&nbsp;
                    <input
                      id="hasPrintServerNo"
                      name="hasPrintServer"
                      type="radio"
                      value="0"
                      checked={!this.state.hasPrintServer}
                      onChange={() => this.setState({ hasPrintServer: false })}
                    />
                    <label htmlFor="hasPrintServerNo">No</label>
                  </td>
                </tr>
                {this.state.hasPrintServer && (
                  <tr id="printserverbox">
                    <td>How many print servers are required?</td>
                    <td>
                      <OnBlurInput
                        type="number"
                        id="numberOfPrintServer"
                        name="numberOfPrintServer"
                        value={this.state.numberOfPrintServer}
                        onConfirm={this.handleInputChange}
                        min="1"
                        placeholder="# of print servers"
                        required={true}
                      />
                    </td>
                  </tr>
                )}
                <tr>
                  <td>
                    Is mobile print ability required?
                    <div className={style.tooltip}>
                      <IconInfo />
                      <div className={style.tooltipText}>
                        Select this to enable mobile printing via email.
                      </div>
                    </div>
                  </td>
                  <td>
                    <input
                      id="requireMobilePrintYes"
                      name="requireMobilePrint"
                      type="radio"
                      value="1"
                      checked={this.state.isMobilePrinterRequired}
                      onChange={() =>
                        this.setState({ isMobilePrinterRequired: true })
                      }
                    />
                    <label htmlFor="requireMobilePrintYes">Yes</label>
                    &nbsp;&nbsp;&nbsp;
                    <input
                      id="requireMobilePrintNo"
                      name="requireMobilePrint"
                      type="radio"
                      value="0"
                      checked={!this.state.isMobilePrinterRequired}
                      onChange={() =>
                        this.setState({ isMobilePrinterRequired: false })
                      }
                    />
                    <label htmlFor="requireMobilePrintNo">No</label>
                  </td>
                </tr>
                {this.state.isMobilePrinterRequired && (
                  <tr id="mobilelicencebox">
                    <td>How many file format licences do you required?</td>
                    <td>
                      <OnBlurInput
                        type="number"
                        id="numberOfMobileLicence"
                        name="numberOfMobileLicence"
                        value=""
                        min="1"
                        required={true}
                        placeholder="# of file format licences"
                      />
                    </td>
                  </tr>
                )}
                <tr id="assessmentperformed">
                  <td>
                    Do you require a Discovery assessment performed?
                    isAssessmentMandatory: {this.isAssessmentMandatory}
                    <div className={style.tooltip}>
                      <IconInfo />
                      <div className={style.tooltipText}>
                        Select this to perform Discovery assessment.
                      </div>
                    </div>
                  </td>
                  <td>
                    <input
                      id="requireDiscoveryAssessmentPerformedYes"
                      name="requireDiscoveryAssessmentPerformed"
                      type="radio"
                      value="1"
                      checked={
                        this.isAssessmentMandatory ||
                        this.state.requireDiscoveryAssessmentPerformed
                      }
                      onChange={() =>
                        this.setState({
                          requireDiscoveryAssessmentPerformed: true
                        })
                      }
                    />
                    <label htmlFor="requireDiscoveryAssessmentPerformedYes">
                      Yes
                    </label>
                    &nbsp;&nbsp;&nbsp;
                    <input
                      id="requireDiscoveryAssessmentPerformedNo"
                      name="requireDiscoveryAssessmentPerformed"
                      type="radio"
                      value="0"
                      checked={
                        !(
                          this.isAssessmentMandatory ||
                          this.state.requireDiscoveryAssessmentPerformed
                        )
                      }
                      onChange={() =>
                        this.setState({
                          requireDiscoveryAssessmentPerformed: false
                        })
                      }
                    />
                    <label htmlFor="requireDiscoveryAssessmentPerformedNo">
                      No
                    </label>
                  </td>
                </tr>
              </tbody>
            </table>
            <hr />
            <input name="calculator_uid" type="hidden" defaultValue="AU_MDS" />
            <Button
              id="calculator-submit-button"
              name="submit"
              type="submit"
              disabled={this.state.isLoading}
            >
              {this.state.isLoading ? "Processing..." : "Add to quote"}
            </Button>
          </form>
        </div>

        {this.state.isSuccess && (
          <div className="add_to_quote_success_modal">
            <div className="modal-overlay success_popup_inner">
              <div className="content">
                <div className="heading">
                  Product has been added to you quote
                </div>
                <div className="item success_msg_container">
                  {this.state.totalAddedQty} products
                </div>
                <div className="cta">
                  <Link className="add" to={"/"}>
                    <span>+</span> Add more products
                  </Link>
                  <Link className="view" to={"/quote"}>
                    View quote
                  </Link>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default connect(null, { addQuoteItem })(MdsCalculator);
